import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CommissionRecordInfo",
  props: {
    commissionRecordInfo: {
      type: Object,
      default: () => ({})
    }
  }
});